module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_5010.c45d7abb.png";